export class Page {
    id: string;
    title: any;
    has_custom_title: any;
    custom_title: any;
    content: any;
    content_top: any;
    custom_seo_data: any;
    seo_title: any;
    seo_description: any;
    [title: string]: any;

    constructor(options: any) {
        this.id = options.id;
        this.title = options.title;
        this.has_custom_title = options.has_custom_title;
        this.custom_title = options.custom_title;
        this.content = options.content;
        this.content_top = options.content_top;
        this.custom_seo_data = options.custom_seo_data;
        this.seo_title = options.seo_title;
        this.seo_description = options.seo_description;
    }
}
